<template>
  <div v-bind:class="{'mega-button' : true, 'disabled' : disabled}">
    <h3>{{ title }}</h3>
    <p>{{ buttonText }}</p>
    <a v-if="!disabled" class="cover" v-bind:href="buttonUrl"></a>
  </div>
</template>

<script>
export default {
  props: ['title', 'buttonText', 'buttonUrl', 'disabled'],
  name: 'MegaButton',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mega-button {
  max-width: 455px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1), 0 4px 8px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.1), 0 0 2px rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  background: $primary url('../assets/icons/plans-launch-group.png') no-repeat 20px center;
  color: $text-light;
  padding: 20px 20px 20px 90px;
  margin-bottom: 60px;
  position: relative;

  &.disabled {
    background-color: $border-beta;
  }

  h3 {
    color: $text-light;
    margin: 0;
  }
  p {
    @extend %type-zeta;
    margin: 0;
  }

  a.cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

}
</style>
